import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Strategy from './pages/Strategy';
import Careers from './pages/Careers';
import JobDetail from './pages/JobDetail';
import Blog from './pages/Blog';
import EmployeePortal from './pages/EmployeePortal';
import ConfigureAdmins from './pages/ConfigureAdmins';
import ContactUs from './pages/ContactUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import './styles/App.css';

function App() {
  
  // Navbar Scroll feature -----------------------------------------------------------------
    const [isMenuVisible, setIsMenuVisible] = useState(true);
    const [lastY, setLastY] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      if (y > lastY && y > 80) setIsMenuVisible(false);   // scrolling down
      else setIsMenuVisible(true);                        // scrolling up
      setLastY(y);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [lastY]);

  // Navbar Scroll feature -----------------------------------------------------------------

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="app">
          {/* Video Background - MP4 */}
          <video 
            className="video-background" 
            autoPlay 
            loop 
            muted 
            playsInline
            ref={video => {
              if (video) {
                video.playbackRate = 0.5;
                video.play().catch(err => console.log('Video autoplay prevented:', err));
              }
            }}
          >
            <source src={require('./assets/background.mp4')} type="video/mp4" />
          </video>
          
          <Navbar className={`navbar ${isMenuVisible ? 'active' : ''}`}/>
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/strategy" element={<Strategy />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/careers/:id" element={<JobDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/employee-portal" element={<EmployeePortal />} />
              <Route path="/admin-portal" element={<EmployeePortal />} /> {/* Redirect old admin portal route */}
              <Route path="/configure-admins" element={<ConfigureAdmins />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-use" element={<TermsOfUse />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;